import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { UniqueIdentifier } from '@dnd-kit/core';
import type { ReactElement, ReactNode, HTMLAttributes } from 'react';

interface SortableItemProps {
  id: UniqueIdentifier;
  disabled?: boolean;
  children: (dragHandleProps: HTMLAttributes<HTMLElement>) => ReactNode;
}

export const SortableItem = ({ id, disabled, children }: SortableItemProps): ReactElement => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id,
    disabled,
  });

  return (
    <div
      ref={setNodeRef}
      style={{
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        zIndex: isDragging ? 10 : undefined,
      }}
    >
      {children({ ...attributes, ...listeners })}
    </div>
  );
}
